import React from 'react'


const Data = () => {
    return(
        <div className="home__data">
            <h1 className="home__title">
                Abdulhamid Shahade
            </h1>
            <h3 className="home__subtitle">
                Full Stack Developer | Backend and AI Systems
            </h3>
            <p className="home__description">
                I build web applications, REST APIs, conversational voice agents, and RAG systems with Python, FastAPI, C#, ASP.NET Core, React, and Next.js.
            </p>
            <div className="home__meta">
                <span><i className="bx bx-map"></i>Istanbul, Turkiye</span>
                <span><i className="bx bx-briefcase-alt"></i>4+ years of experience</span>
                <span><i className="bx bx-building-house"></i>Callby.ai</span>
            </div>
            <div className="home__actions">
                <a href="#contact" className="home__button">
                    Contact Me
                    <i className="bx bx-envelope home__button-icon"></i>
                </a>
                <a href="#project" className="home__button home__button--ghost">
                    View Berryfy
                    <i className="bx bx-right-arrow-alt home__button-icon"></i>
                </a>
            </div>
        </div>
    )
}

export default Data;
